var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01526 20.0909H2.68698C1.51475 20.0909 0.555664 19.1318 0.555664 17.9596V3.04043C0.555664 1.86821 1.51475 0.909119 2.68698 0.909119H21.8688C23.041 0.909119 24.0001 1.86821 24.0001 3.04043V6.2374C24.0001 6.87679 23.5738 7.30306 22.9344 7.30306C22.295 7.30306 21.8688 6.87679 21.8688 6.2374V3.04043H2.68698V17.9596H8.01526C8.65465 17.9596 9.08091 18.3859 9.08091 19.0253C9.08091 19.6647 8.65465 20.0909 8.01526 20.0909Z",
    fill: "#0273B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8685 20.0909H13.3432C12.171 20.0909 11.2119 19.1318 11.2119 17.9596V11.5656C11.2119 10.3934 12.171 9.43433 13.3432 9.43433H21.8685C23.0407 9.43433 23.9998 10.3934 23.9998 11.5656V17.9596C23.9998 19.1318 23.0407 20.0909 21.8685 20.0909ZM13.3432 11.5656V17.9596H21.8685V11.5656H13.3432Z",
    fill: "#0273B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/fullScreen.6083f3150f461b9464ebcba13205ad0d.svg";
export { ForwardRef as ReactComponent };